import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_URL_API;

class RecoveryParamsService {


    getRecoveryRules(){
        return axios.get(API_URL + 'recovery_rules' , { headers: authHeader() });
    }

    getRecoverySatges(){
        return axios.get(API_URL + 'recovery_correspondences' , { headers: authHeader() });
    }

}

export default new RecoveryParamsService();
